import { BirdviewTrend } from '../DashboardBirdview.constants.charts'

export const BIRDVIEW_FLOW_TREND_HEADLINE_KEY = {
  [BirdviewTrend.Down]: 'DashboardBirdview.ChartBacklogShrinkingKey',
  [BirdviewTrend.Flat]: 'DashboardBirdview.ChartBacklogSteadyKey',
  [BirdviewTrend.Up]: 'DashboardBirdview.ChartBacklogGrowingKey',
}

export const BIRDVIEW_FLOW_CHART_GRID_PROPS = {
  stroke: 'var(--color-border)',
  vertical: false,
}
